module.exports = __webpack_public_path__ + "static/media/GUIDE_0009_03.3ae9e22e.webp";